<app-skeleton *ngIf="loading" variant="text" [count]="6"
  label="Carregando o disparo de voz" data-testid="broadcast-call-loading"></app-skeleton>

<div *ngIf="!loading && broadcast">
  <header class="page-head" data-testid="view-broadcast-call-section">
    <div class="page-head__identity">
      <span class="page-head__icon"><i class="fa fa-phone"></i></span>
      <div>
        <h1 class="page-head__title">Broadcast de Voz</h1>
        <p class="page-head__subtitle">
          <strong>{{ broadcast.name }}</strong> ·
          <span class="m8v-status-pill m8v-status-pill--sm" [ngClass]="'m8v-status-pill--' + statusTone" data-testid="broadcast-call-status">
            <span class="dot"></span>{{ statusLabel }}
          </span>
        </p>
      </div>
    </div>
    <div class="page-head__actions">
      <a [routerLink]="['/broadcasts-call/edit', broadcast.id]" class="sf-btn sf-btn--primary sf-btn--pill" *ngIf="isScheduled" data-testid="btn-edit">
        <i class="fa fa-pencil"></i> Alterar
      </a>

      <a [routerLink]="['/broadcasts-call']" class="sf-btn sf-btn--secondary sf-btn--pill" data-testid="btn-back">
        <i class="fa fa-chevron-left"></i> Voltar
      </a>

      <button
        *ngIf="isActive"
        type="button"
        class="sf-btn sf-btn--secondary sf-btn--pill"
        (click)="pauseBroadcast()"
        title="Pausar"
      >
        <i class="fa fa-pause"></i> Pausar
      </button>

      <button
        *ngIf="isPaused"
        type="button"
        class="sf-btn sf-btn--secondary sf-btn--pill"
        (click)="resumeBroadcast()"
        title="Retomar"
      >
        <i class="fa fa-play"></i> Retomar
      </button>

      <button
        *ngIf="canCancel"
        type="button"
        class="sf-btn sf-btn--danger sf-btn--pill"
        (click)="confirmCancel()"
        title="Cancelar"
      >
        <i class="fa fa-times"></i> Cancelar
      </button>

      <button type="button" class="sf-btn sf-btn--secondary sf-btn--pill" (click)="exportCsv()" title="Exportar CSV">
        <i class="fa fa-download"></i> Exportar CSV
      </button>

      <a [routerLink]="['/broadcasts-call/new']" class="sf-btn sf-btn--secondary sf-btn--pill">
        Criar Broadcast de Voz <i class="fa fa-plus"></i>
      </a>
    </div>
  </header>

  <!-- Barra de progresso enquanto está ligando -->
  <div class="card mb-3" *ngIf="isInProgress && progressPercent != null" data-testid="progress-bar">
    <div class="d-flex align-items-center" style="gap: 12px; padding: 4px 6px;">
      <div style="flex: 1; height: 8px; border-radius: 999px; overflow: hidden; background: rgba(255,255,255,.08);">
        <div style="height: 100%; border-radius: 999px; background: var(--accent-cool, #38bdf8);" [style.width.%]="progressPercent"></div>
      </div>
      <strong style="color: #fff;">{{ progressPercent }}%</strong>
      <span style="color: rgba(255,255,255,.7); font-size: .8rem;">
        {{ broadcast.total_sent ?? 0 }} de {{ totalContacts }} contatos ligados · atualiza sozinho enquanto estiver Processando/Ligando
      </span>
    </div>
  </div>

  <!-- Aguardando retorno do provedor -->
  <div class="alert alert-info vbc-notice" *ngIf="awaitingCallbacks > 0" data-testid="awaiting-callbacks-notice">
    <i class="fa fa-hourglass-half"></i>
    <div>
      <strong>{{ awaitingCallbacks }} {{ awaitingCallbacks === 1 ? 'ligação ainda sem retorno' : 'ligações ainda sem retorno' }} do provedor.</strong>
      Os totais fecham quando os callbacks chegarem.
    </div>
  </div>

  <!-- Indicadores do relatório -->
  <div class="m8v-kpis" *ngIf="report" data-testid="broadcast-call-kpis">
    <div class="m8v-kpi">
      <h4><i class="fa fa-phone ic"></i>Total Enviados</h4>
      <b>{{ report.total_sent }}</b>
    </div>
    <div class="m8v-kpi danger">
      <h4><i class="fa fa-ban ic"></i>Recusada / Não Atendida</h4>
      <b>{{ report.total_refused }}</b>
    </div>
    <div class="m8v-kpi warn">
      <h4><i class="fa fa-phone ic"></i>Atendida e Desligada</h4>
      <b>{{ report.total_answered_hangup }}</b>
    </div>
    <div class="m8v-kpi ok">
      <h4><i class="fa fa-check-circle ic"></i>Escutada até o Fim</h4>
      <b>{{ report.total_answered_listened }}</b>
    </div>
    <div class="m8v-kpi violet">
      <h4><i class="fa fa-hashtag ic"></i>Atendida com Digitação</h4>
      <b>{{ report.total_answered_dtmf }}</b>
    </div>
    <div class="m8v-kpi">
      <h4><i class="fa fa-clock-o ic"></i>Duração Média</h4>
      <b>{{ formatDuration(report.avg_duration_seconds) }}</b>
    </div>
    <div class="m8v-kpi cool">
      <h4><i class="fa fa-volume-up ic"></i>% Médio Escutado</h4>
      <b>{{ report.avg_listened_percentage != null ? (report.avg_listened_percentage | number : '1.1-1') + '%' : '-' }}</b>
    </div>
    <div class="m8v-kpi">
      <h4><i class="fa fa-money ic"></i>Créditos Usados</h4>
      <b>{{ report.total_credits_used }}</b>
    </div>
  </div>

  <!-- Dados do broadcast -->
  <div class="card mb-4" style="padding: 18px 20px;">
    <dl class="m8v-def-grid">
      <div class="m8v-def">
        <dt>Campanha</dt>
        <dd>{{ broadcast.name }}</dd>
      </div>
      <div class="m8v-def">
        <dt>Data/Hora do Envio</dt>
        <dd>{{ broadcast.scheduled_date ? (brasiliaIso(broadcast.scheduled_date) | date : 'dd/MM/yyyy, H:mm' : '-0300') : 'Imediato' }}</dd>
      </div>
      <div class="m8v-def" *ngIf="broadcast.scheduled_end_date">
        <dt>Fim agendado</dt>
        <dd>{{ brasiliaIso(broadcast.scheduled_end_date) | date : 'dd/MM/yyyy, H:mm' : '-0300' }}</dd>
      </div>
      <div class="m8v-def">
        <dt>Criado em</dt>
        <dd>{{ brasiliaIso(broadcast.created_at) | date : 'dd/MM/yyyy, H:mm' : '-0300' }}</dd>
      </div>
      <div class="m8v-def" *ngIf="broadcast.leadList">
        <dt>Lista</dt>
        <dd><i class="fa fa-list-ul"></i> {{ broadcast.leadList.name }}</dd>
      </div>
      <div class="m8v-def">
        <dt>Tentativas máximas</dt>
        <dd>{{ broadcast.max_attempts }}</dd>
      </div>
      <div class="m8v-def">
        <dt>Intervalo entre tentativas (min)</dt>
        <dd>{{ broadcast.retry_interval_minutes || '—' }}</dd>
      </div>
      <div class="m8v-def" *ngIf="broadcast.postback_url">
        <dt>URL de Postback</dt>
        <dd><span class="m8v-copy-field"><code>{{ broadcast.postback_url }}</code></span></dd>
      </div>
      <div class="m8v-def wide" *ngIf="broadcast.call4uAudio">
        <dt>Áudio</dt>
        <dd style="display: block;">
          {{ broadcast.call4uAudio.name }}
          <audio controls style="display: block; margin-top: 6px; max-width: 420px;" *ngIf="broadcast.call4uAudio.url" [src]="broadcast.call4uAudio.url" data-testid="audio-player"></audio>
        </dd>
      </div>
    </dl>
  </div>

  <!-- Webhooks de Integração ─────────────────────────────────────────
       URLs públicas que plataformas externas (Monetizze, ActiveCampaign,
       PerfectPay, etc.) usam pra empurrar contatos pro broadcast. As URLs
       espelham o formato legado do Call4U (/api/integrations/{action}/{hash}/{plataforma})
       e o hash é preservado durante a migração para que clientes externos
       não precisem atualizar nada externamente. -->
  <div class="m8v-acc" [class.open]="webhooksOpen" *ngIf="broadcast?.webhook_hash" data-testid="webhooks-accordion">
    <div
      class="m8v-acc__hd"
      role="button"
      tabindex="0"
      [attr.aria-expanded]="webhooksOpen"
      (click)="webhooksOpen = !webhooksOpen"
      (keydown.enter)="webhooksOpen = !webhooksOpen"
      (keydown.space)="$event.preventDefault(); webhooksOpen = !webhooksOpen">
      <i class="fa fa-link"></i>
      <strong>Webhooks de Integração</strong>
      <small style="color: rgba(255,255,255,.6); font-weight: 500;">URLs para integrar plataformas externas</small>
      <i class="fa fa-chevron-down chev"></i>
    </div>

    <div class="m8v-acc__bd" *ngIf="webhooksOpen">
      <div *ngIf="!isWebhookBasePublic" class="alert alert-warning vbc-notice mb-2">
        <i class="fa fa-exclamation-triangle"></i>
        <div>
          <strong>Atenção:</strong> você está em ambiente DEV/local. As URLs abaixo
          apontam pra um host não público — não cole em plataformas externas
          (Monetizze, ActiveCampaign, etc.), elas não vão alcançar este servidor.
        </div>
      </div>
      <p class="field-hint" style="margin: 8px 0 14px;">
        Configure essas URLs nos webhooks da plataforma de origem. Toda requisição
        adiciona ou remove um contato deste broadcast. Plataformas com
        <span class="m8v-status-pill m8v-status-pill--sm">Em breve</span> aceitam a chamada (200) mas
        ainda não processam o payload — entre em contato com o suporte se precisar
        de uma delas ativa.
      </p>

      <div class="m8v-acc" [class.open]="expandedPlatform === p.key" *ngFor="let p of webhookPlatforms" [attr.data-testid]="'webhook-platform-' + p.key">
        <div
          class="m8v-acc__hd"
          role="button"
          tabindex="0"
          [attr.aria-expanded]="expandedPlatform === p.key"
          (click)="togglePlatform(p.key)"
          (keydown.enter)="togglePlatform(p.key)"
          (keydown.space)="$event.preventDefault(); togglePlatform(p.key)">
          <strong>{{ p.label }}</strong>
          <span class="m8v-status-pill m8v-status-pill--sm" [class.m8v-status-pill--ok]="p.active">
            {{ p.active ? 'Ativo' : 'Em breve' }}
          </span>
          <i class="fa fa-chevron-down chev"></i>
        </div>

        <div class="m8v-acc__bd" *ngIf="expandedPlatform === p.key">
          <div class="field mb-2">
            <label class="small">Adicionar contato</label>
            <span class="m8v-copy-field">
              <code>{{ webhookUrl('add', p.key) }}</code>
              <button class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" type="button" (click)="copyWebhookUrl(webhookUrl('add', p.key))" title="Copiar">
                <i class="fa fa-copy"></i>
              </button>
            </span>
          </div>

          <div class="field mb-2">
            <label class="small">Remover contato</label>
            <span class="m8v-copy-field">
              <code>{{ webhookUrl('remove', p.key) }}</code>
              <button class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" type="button" (click)="copyWebhookUrl(webhookUrl('remove', p.key))" title="Copiar">
                <i class="fa fa-copy"></i>
              </button>
            </span>
          </div>

          <div class="field" *ngIf="p.active && p.sample">
            <label class="small">Exemplo de payload (JSON)</label>
            <pre class="webhooks-payload p-2 small rounded mb-0"><code>{{ p.sample }}</code></pre>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Contatos -->
  <div class="m8v-filter-bar" style="margin-top: 20px;">
    <h5 class="section-title" style="margin: 0;">Contatos</h5>
    <div class="m8v-search" style="margin-left: auto;">
      <i class="fa fa-search ic"></i>
      <input
        type="text"
        class="form-control"
        placeholder="(99) 99999-9999"
        [(ngModel)]="phone"
        name="phone"
        (keyup.enter)="filterByPhone()"
        data-testid="input-phone-filter"
      />
      <button type="button" class="go" (click)="filterByPhone()" title="Pesquisar" data-testid="btn-phone-filter">
        <i class="fa fa-search"></i>
      </button>
    </div>
  </div>

  <app-skeleton *ngIf="loadingContacts" variant="table-row" [count]="6" [columns]="4"
    label="Carregando os contatos" data-testid="contacts-loading"></app-skeleton>

  <div *ngIf="!loadingContacts && contacts && contacts.data.length === 0" class="m8v-empty" data-testid="contacts-empty">
    <i class="fa fa-search ic"></i>
    <h3>Nenhum contato encontrado</h3>
    <p>Nenhum telefone bate com o filtro.</p>
    <div class="acts">
      <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="clearPhoneFilter()" data-testid="btn-clear-phone-filter">
        <i class="fa fa-times"></i> Limpar filtro
      </button>
    </div>
  </div>

  <div class="card" style="padding: 0 6px;" *ngIf="!loadingContacts && contacts && contacts.data.length > 0">
    <div class="table-responsive">
      <table class="table table-hover elevated mb-0">
        <thead>
          <tr>
            <th>Telefone</th>
            <th>Tentativa</th>
            <th>Status</th>
            <th>Disparo Ligação</th>
            <th>Retorno Usuário</th>
            <th>Duração</th>
            <th>Ouvido (%)</th>
            <th>Resposta DTMF</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let contact of contacts.data" data-testid="contact-row">
            <td>{{ contact.phone }}</td>
            <td>{{ contact.tries }}/{{ contact.max_attempts }}</td>
            <td>
              <span class="m8v-status-pill m8v-status-pill--sm" [ngClass]="'m8v-status-pill--' + contactStatusTone(contact)">
                {{ getContactStatusLabel(contact) }}
              </span>
            </td>
            <td>
              <span *ngIf="contact.sent_at">{{ brasiliaIso(contact.sent_at) | date : 'dd/MM/yyyy, H:mm' : '-0300' }}</span>
              <span *ngIf="!contact.sent_at">-</span>
            </td>
            <td>
              <span *ngIf="contact.callback_received_at">{{ brasiliaIso(contact.callback_received_at) | date : 'dd/MM/yyyy, H:mm' : '-0300' }}</span>
              <span *ngIf="!contact.callback_received_at">-</span>
            </td>
            <td>{{ formatDuration(contact.call_duration_seconds) }}</td>
            <td>{{ contact.listened_percentage != null ? (contact.listened_percentage | number : '1.1-1') + '%' : '-' }}</td>
            <td>{{ contact.dtmf_response || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <app-pagination
    *ngIf="contacts"
    [currentPage]="contacts.current_page"
    [itemsPerPage]="contacts.per_page"
    [totalItems]="contacts.total"
    (pageChanged)="pageChanged($event)"
  >
  </app-pagination>
</div>
